routes.$inject = ['$stateProvider']

export default function routes($stateProvider) {
  $stateProvider
    .state('shell.events', {
      url: '/events',
      template: require('./events.html'),
      controller: 'EventsController',
      controllerAs: 'events',
      resolve: {
        $title: function() {
          return 'Events'
        }
      }
    })
    .state('shell.event', {
      url: '/events/:slug',
      template: require('./event.html'),
      controller: 'EventController',
      controllerAs: 'event',
      resolve: {
        event: ['EventService', '$stateParams', function(EventService, $stateParams) {
          return EventService.getEvent(sessionStorage.getItem('profileId'), $stateParams.slug)
        }],
        $title: ['event', function(event) {
          return event.data.event
        }]
      },
      params: {
        activeTab: null,
        search: null
      }
    })
    .state('shell.booking', {
      url: '/bookings/:referenceNo',
      template: require('./booking.html'),
      controller: 'BookingController',
      controllerAs: 'booking',
      resolve: {
        booking: ['EventService', '$stateParams', function(EventService, $stateParams) {
          return EventService.getBooking($stateParams.referenceNo).then(res => res.data)
        }],
        $title: ['booking', function(booking) {
          var name
          if (booking.contactId) {
            name = booking.contact.lastName ? booking.contact.firstName + ' ' + booking.contact.lastName : booking.contact.firstName
          } else {
            name = ''
          }
          return 'Ref. &#35;' + booking.referenceNo + ' ' + name
        }]
      }
    })
    .state('shell.newEvent', {
      url: '/events/new',
      template: require('./new-event.html'),
      controller: 'NewEventController',
      controllerAs: 'newEvent',
      resolve: {
        $title: function() {
          return 'New Event'
        }
      }
    })
}